<template>
  <div v-if="hasMultipleTabs">
    <div class="container-fixed offset-top-2" v-html="$t(`${localeNamespace}.header_order_overview_general_info`)" />
    <VTabset grayed slim unselect @select:tab="onSelect">
      <VTab v-if="isContractSearchAllowed || contractHash" :label="`${localeNamespace}.tabContract`" name="contract" :active="active === 'contract'" />
      <VTab v-if="isCustomerSearchAllowed || customerHash" :label="`${localeNamespace}.tabCustomer`" name="customer" :active="active === 'customer'" />
    </VTabset>
  </div>
  <div v-else class="container-fixed offset-top-2" />
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import VTabset from './Tabset';
import VTab from './Tab';
import { CUSTOMER_SEARCH_REDIRECT, CONTRACT_SEARCH_REDIRECT } from '@route-types';

export default {
  name: 'ContractCustomerTabs',

  components: {
    VTabset,
    VTab,
  },

  props: {
    localeNamespace: {
      type: String,
      required: true,
    },
    hideCustomerView: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      active: null,
    };
  },

  computed: {
    ...mapGetters('system', ['isContractSearchAllowed', 'isCustomerSearchAllowed', 'showInformationCustomerData']),

    ...mapState('system', ['readOnlyAccess']),

    ...mapGetters('shared', ['isCustomerTab']),

    ...mapState('contract', ['contractHash']),

    ...mapState('customer', ['customerHash']),

    hasMultipleTabs() {
      if (this.hideCustomerView || !this.showInformationCustomerData || this.readOnlyAccess) return false;
      if (!this.contractHash !== !this.customerHash) return false;
      return (this.isContractSearchAllowed || this.contractHash) && (this.isCustomerSearchAllowed || this.customerHash);
    },
  },

  watch: {
    active: 'onChange',
  },

  created() {
    if (this.hideCustomerView || !this.showInformationCustomerData || this.readOnlyAccess) {
      this.active = 'contract';
    } else if (this.isCustomerTab) {
      this.active = 'customer';
    } else if (this.contractHash) {
      this.active = 'contract';
    } else if (this.customerHash) {
      this.active = 'customer';
    } else if (!this.isContractSearchAllowed && this.isCustomerSearchAllowed) {
      this.active = 'customer';
    } else if (!this.isCustomerSearchAllowed && this.isContractSearchAllowed) {
      this.active = 'contract';
    }
  },

  methods: {
    onSelect(tab) {
      this.active = tab.name;
    },

    onChange() {
      if (this.active === 'contract' && !this.contractHash) {
        this.$router.push({
          name: CONTRACT_SEARCH_REDIRECT,
          params: {
            errorSelectContract: true,
            originalToName: this.$route.name,
            originalToParams: this.$route.params,
          },
        });
        return;
      }

      if (this.active === 'customer' && !this.customerHash) {
        this.$router.push({
          name: CUSTOMER_SEARCH_REDIRECT,
          params: {
            errorSelectCustomer: true,
            originalToName: this.$route.name,
            originalToParams: this.$route.params,
          },
        });
        return;
      }

      this.$store.dispatch('shared/setCustomerTab', this.active === 'customer');
      this.$emit('change', this.active);
    },
  },
};
</script>
